export enum StatusType {
  Initial = 'Initial',
  Active = 'Active',
  Complete = 'Complete',
  Closed = 'Closed',
}

export type PostStatus = {
  _id: string;
  color: string;
  name: string;
  type: StatusType;
  urlName: string;
};

export type IdeaStatus = {
  _id: string;
  color: string;
  name: string;
  order: number;
  type: StatusType;
  urlName: string;
};

export type APIIdeaStatus = {
  id: string;
  name: string;
  type: StatusType;
  urlName: string;
};
